import { render } from "./UserSetupNotifications.vue?vue&type=template&id=23553f7c"
import script from "./UserSetupNotifications.vue?vue&type=script&lang=js"
export * from "./UserSetupNotifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__